module.exports = __webpack_public_path__ + "static/img/2.57f14df.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/2/2/sp/2.png
// module id = 1HNA
// module chunks = 0